var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 13.562l4.073-4.073a.725.725 0 01.522-.213.707.707 0 01.532.213c.145.145.217.32.217.527a.717.717 0 01-.217.527l-4.494 4.494a.83.83 0 01-.633.255.83.83 0 01-.633-.256l-4.494-4.493a.725.725 0 01-.212-.523.707.707 0 01.212-.531.718.718 0 01.527-.218c.206 0 .382.073.527.218L12 13.562z"
  })));
}
export default __webpack_public_path__ + "assets/static/media/down-arrow.063b82ab.svg";
export { SvgDownArrow as ReactComponent };